import { Injectable, EventEmitter } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';

import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Message } from 'primeng/primeng';
import * as alaSQLSpace from 'alasql';
import { PopupInit } from './init-popup';
import { GlobalInfo, RoleGroups, RoleAccess, PageKey, PageKeyIds, LanguageKeys, SystemSetting, CurrencySymbols, Distance,SaveProductCategory,SaveContractType, ConfigSettings, AttachmentsModel, JobStatus, ConversationMessage, NewNumber, NewGroup, AttachmentCategoryandTag, CompanyMaster, ProjectEntity, JobStatusColorCode, WoStatusColorCode, QOStatusColorCode, FPResponse } from './shared.model';
import { API, CURRENCIES, SETTINGS } from '../core/app-config';
import { MenuItem } from '../menu/menu.model';
import { AuthService } from '../../authentication/auth.service';
import { Customerdetails, CustomerDetailsListEntity } from '../work-order/work-order-models';
import { CustomerType, CustomerTypeSaveEntity } from '../customer/customer-type/customer-type.model';
interface Scripts {
  name: string;
  src: string;
}
@Injectable()
export class SharedService {
  fileUploadStatusEmitter: EventEmitter<any> = new EventEmitter();
  notification: EventEmitter<Message> = new EventEmitter();
  emitSystemSettings: EventEmitter<any> = new EventEmitter();
  emailJob: EventEmitter<any> = new EventEmitter();
  quoteemailJob: EventEmitter<any> = new EventEmitter();
  distanceemit: EventEmitter<any> = new EventEmitter();
  emitAuditlog: EventEmitter<any> = new EventEmitter();
  emitQuoteAuditlog: EventEmitter<any> = new EventEmitter();
  reportDateRangeemit: EventEmitter<any> = new EventEmitter();
  TaxEnable: EventEmitter<any> = new EventEmitter();
  isEnablePolygonRegionEmit: EventEmitter<any> = new EventEmitter();
  isEnablePreferredVendorEmit: EventEmitter<any> = new EventEmitter();
  constructor(private http: Http, private authService: AuthService) { }
  //public baseUrl = SETTINGS.BASEROUTE;
  public isAccessDenied: boolean = false;
  public datexRange: number = 10;
  public gridRowCount: number = 10;
  public innergridRowCount: number = 10;
  //Added by Anvardeen Batcha
  isEnableTax: boolean = false;
  public isDefaultTax: string;
  isEnablePolygonRegion: boolean = false;
  isEnablePreferredVendor: boolean;
  /** Region Get Global Info */
  private _globalInfo: GlobalInfo;
  public auditMessage: string = "";
  public distance: Distance = 0;
  public reportDateRange: number = 10;
  public dashboardDateRange: number = 10;
  public getItem(key: string) {
    return localStorage.getItem(key);
  }
  public setItem(key: string, data: string) {
    localStorage.setItem(key, data);
  }

  public globalInfo(): GlobalInfo {

    //if (!this._globalInfo || !this._globalInfo.LoginId)
    this._globalInfo = {
      CompanyId: +this.getItem('CompanyId'),
      ProductCategoryId: +this.getItem('ProductCategoryId'),
      LoginId: +this.getItem('LoginId'),
      Email: this.getItem('Email'),
      CountryId: +this.getItem('CountryId'),
      DisplayName: this.getItem('DisplayName'),
      Culture: this.getItem('Culture') || 'en-US',
      LanguageId: +(this.getItem('LanguageId') || 16),
      CurrentLangId: +(this.getItem('PreferedLangId') || this.getItem('LanguageId')),
      Resource: (this.getItem('CompanyCode') || '') + '-' + (LanguageKeys[(this.getItem('PreferedLangId') || this.getItem('LanguageId'))]),
      ResourceLanguage: LanguageKeys[(this.getItem('PreferedLangId') || this.getItem('LanguageId'))],
      // Resource: (this.getItem('CompanyCode') || '') + '-' + (this.getItem('Language') || 'en'),
      ResourceDefault: 'en',
      // ResourceDefault: LanguageKeys[this.getItem('LanguageId')],
      Roles: this.getItem('Roles') ? JSON.parse(this.getItem('Roles')) : [],
      ThemeId: this.getItem('ThemeId') || '1',
      MaxRoleGroup: +this.getItem('MaxRoleGroup') || RoleGroups.SiteAdmin,
      VendorId: +this.getItem('VendorId') || 1,
      IsManager: this.getItem('IsManager') == "true" || this.getItem('IsManager') == "True" ? true : this.getItem('IsManager') == "false" || this.getItem('IsManager') == "False" ? false : null,
      TimeZoneId: +this.getItem('TimeZoneId') || 1,
      HomePageId: +this.getItem('HomePageId') || 0,
      BusinessAddressId: +this.getItem('BusinessAddressId'),
      Mpin: this.getItem('Mpin'),
      Managerid: +this.getItem('Managerid'),
      IsTech: this.getItem('IsTech') == "true" || this.getItem('IsTech') == "True" ? true : this.getItem('IsTech') == "false" || this.getItem('IsTech') == "False" ? false : null,
      LogoPath: this.getItem('LogoPath'),
      MapId: this.getItem('MapId'),
      MapKey: this.getItem('MapKey'),
      ZoneId: 0,
      IsLatLonBased: this.getItem('IsLatLonBased') == '1' ? true : false,
      DefaultCountryId: +this.getItem('DefaultCountryId'),
      ProjectEnabled: +this.getItem('IsProjectEnabled'),
      ReturnURL: this.getItem('ReturnURL'),
      LicenseExpired: this.getItem('LicenseExpired'),
      PasswordExpired: this.getItem('PasswordExpired'),
      CompanyCode: this.getItem('CompanyCode'),
      SpeechLang: LanguageKeys[(this.getItem('PreferedLangId') || this.getItem('LanguageId'))],
      Currency: '$',
      // Added by Yogesh M on 21/08/2020 for Accessible Worktypes and regions start
      HasAccessToAllRegions: this.getItem('HasAccessToAllRegions') == "true" || this.getItem('HasAccessToAllRegions') == "True" ? true : this.getItem('HasAccessToAllRegions') == "false" || this.getItem('HasAccessToAllRegions') == "False" ? false : null,
      HasAccessToAllWorkTypes: this.getItem('HasAccessToAllWorkTypes') == "true" || this.getItem('HasAccessToAllWorkTypes') == "True" ? true : this.getItem('HasAccessToAllWorkTypes') == "false" || this.getItem('HasAccessToAllWorkTypes') == "False" ? false : null
      // Added by Yogesh M on 21/08/2020 for Accessible Worktypes and regions end
    };

    let currency = CURRENCIES.find(f => f.code == this.getItem('Currency'));
    this._globalInfo.Currency = ((currency && currency.symbol) ? currency.symbol : this._globalInfo.Currency);

    /*switch (this.getItem('Currency')) {
      case "USD":
        this._globalInfo.Currency = CurrencySymbols.USD;
        break;
      case "GBP":
        this._globalInfo.Currency = CurrencySymbols.GBP;
        break;
      case "SGD":
        this._globalInfo.Currency = CurrencySymbols.SGD;
        break;
      case "EUR":
        this._globalInfo.Currency = CurrencySymbols.EUR;
        break;
      case "AED":
        this._globalInfo.Currency = CurrencySymbols.AED;
        break;
      case "VND":
        this._globalInfo.Currency = CurrencySymbols.VND;
        break;
      case "MYR":
        this._globalInfo.Currency = CurrencySymbols.MYR;
        break;
      case "SAR":
        this._globalInfo.Currency = CurrencySymbols.SAR;
        break;
      case "INR":
        this._globalInfo.Currency = CurrencySymbols.INR;
        break;
      case "EGP":
        this._globalInfo.Currency = CurrencySymbols.EGP;
        break;
      case "BDT":
        this._globalInfo.Currency = CurrencySymbols.BDT;
        break;
      case "MMK":
        this._globalInfo.Currency = CurrencySymbols.MMK;
        break;
      case "PKR":
        this._globalInfo.Currency = CurrencySymbols.PKR;
        break;

    }*/
    return this._globalInfo;
  }
  resetGlobalInfo() {
    this._globalInfo = null;
  }
  /** Region Get Global Info ends */

  public yearRange: string = (new Date().getFullYear() - 15).toString() + ':' + (new Date().getFullYear() + 35).toString();
  getStatus() {
    return [
      new Status(1, 'Active'),
      new Status(0, 'Inactive'),
      new Status(-1, 'All')
    ];
  }
  getIsOptional() {
    return [
      new IsOptional(1, 'Yes'),
      new IsOptional(0, 'No')
    ];
  }
  getRowsPerOptions() {
    return [10, 25, 50, 75, 100];
  }
  getRows() {
    let lc = localStorage.getItem('gridRowCount');
    if (lc && +lc > 0)
      this.gridRowCount = +lc;
    return this.gridRowCount;
  }
  getPanelRows() {
    return this.innergridRowCount;
  }
  getEnableTax() {
    return this.isEnableTax;
  }

  getEnableEnablePolygonRegion() {
    return this.isEnablePolygonRegion;
  }

  getEnablePreferredVendor() {
    return this.isEnablePreferredVendor;
  }

  //For Resource File
  getLanguageList() {
    return [
      new Language(-1, 'All'),
      new Language(1, 'English'),
      new Language(2, 'French')

    ];
  }

  //For Resource File
  getViewMode() {
    return [
      new ViewMode(1, 'Job Only'),
      new ViewMode(2, 'Technician Only'),
      new ViewMode(3, 'Technician & Job')
    ];
  }

  getOptimizationMode() {
    return [
      new OptimizationViewMode(1, 'Map'),
      new OptimizationViewMode(2, 'Dispatch'),
    ];
  }

  getLiveMapType() {
    return [
      new LiveMapType(0, 'None'),
      new LiveMapType(1, 'Bing'),
      new LiveMapType(2, 'Google')
    ];
  }
  getDefaultCountryLatLong() {
    return [
      new DefaultCountryLatLong(1, 'USA', 40.7143528, -74.0059731),
      new DefaultCountryLatLong(2, 'SINGAPORE', 1.3553794, 103.8677444),
      new DefaultCountryLatLong(3, 'CANADA', 56.130366, -106.346771),
      new DefaultCountryLatLong(6, 'UAE', 25.276987, 55.296249),
      new DefaultCountryLatLong(11, 'MALAYSIA', 3.1390, 101.6869),
      new DefaultCountryLatLong(13, 'INDIA', 22.684367, 79.043024),
      new DefaultCountryLatLong(46, 'BANGLADESH', 23.8820, 90.2808),
      new DefaultCountryLatLong(47, 'MYANMAR', 21.9162, 95.9560),
      new DefaultCountryLatLong(48, 'PAKISTAN', 30.3753, 69.3451),
      new DefaultCountryLatLong(51, 'SAUDI ARABIA', 24.774265, 46.738586)
    ];
  }
  getScope() {
    return [
      new Scope(0, 'General'),
      new Scope(1, 'Customer'),
      new Scope(2, 'Customer Type'),
      new Scope(3, 'Project')
    ];
  }
  //service - Api calls
  getChildPrivileges(CompanyId: number, LoginId: number, ParentMenuId: PageKey, MenuId: PageKey = null): Observable<RoleAccess[]> {
    return this.http.get(API.USER + "/GetChildPrivileges/" + CompanyId + '/' + LoginId + '/' + ParentMenuId + '/' + MenuId).pipe(map(res => res.json()));
  }
  getChildPrivilegesList(CompanyId: number, LoginId: number, Ids: PageKeyIds[]): Observable<RoleAccess[]> {
    return this.http.put(API.USER + "/GetChildPrivileges/" + CompanyId + '/' + LoginId, Ids).pipe(map(res => res.json()));
  }
  RemoveChildPrivilegesCache(): Observable<boolean> {
    return this.http.get(API.USER + "/RemoveChildPrivilegesCache").pipe(
      map((res: Response) => res.json()),
      catchError(this.handleError<boolean>('logout', false))
    );
  }
  getJobstatuslist(CompanyId: number): Observable<JobStatus[]> {
    return this.http.get(API.REPORTSTATUS + "/GetJobstatus/" + CompanyId).pipe(map(res => res.json()));
  }
  GetWorkOrderStatus(CompanyId: number) {
    return this.http.get(API.WOCOMPANYMASTER + '/GetMasterEntityWOStatus/?CompanyId=' + CompanyId).pipe(map(resp => resp.json()));
  }

  GetJobStatus(companyId: number) {
    return this.http.get(API.WOCOMPANYMASTER + '/GetMasterEntityJobStatus/?CompanyId=' + companyId).pipe(map(resp => resp.json()));
  }
  //Export to excel
  exportExcel(sheetId: string, fileName: string, columns: string, data: any) {


    var query = 'SELECT ' + columns + ' INTO XLSX("' + fileName + '",?) FROM ?';
    var opts = [{ sheetid: sheetId, header: true }];
    var res = alasql(query, [opts, [data]]);


  }
  getIsTaxEnabled(CompanyId: number) {
    return this.http.get(API.COMPANY + "/GetIsTaxEnabled/" + CompanyId).pipe(map(resp => resp.json()));
  }
  //File Upload
  isFileTypeValid(file: File, accept: string): boolean {
    let acceptableTypes = accept.split(',');
    for (let type of acceptableTypes) {
      let acceptable = this.isWildcard(type) ? this.getTypeClass(file.type) === this.getTypeClass(type)
        : this.getFileExtension(file) === type;
      if (acceptable) {
        return true;
      }
    }
    return false;
  }

  isFileTypeValidtechjob(file: File[], accept: string): boolean {

    let i = 0;
    let flag = 0;
    file.forEach(x => {

      i == 0 ? flag = 0 : flag++;



      let acceptableTypes = accept.split(',');
      for (let type of acceptableTypes) {
        let acceptable = this.isWildcard(type) ? this.getTypeClass(x.type) === this.getTypeClass(type)
          : this.getFileExtension(file[flag]) === type;
        if (acceptable) {
          i++;
          //  return true;
        }

      }

    });
    if (i == file.length) {
      return true;
    }
    else {
      return false;
    }
  }

  getTypeClass(fileType: string): string {
    return fileType.substring(0, fileType.indexOf('/'));
  }

  isWildcard(fileType: string): boolean {
    return fileType.indexOf('*') !== -1;
  }

  getFileExtension(file: File): string {
    return '.' + file.name.split('.').pop();
  }

  isImage(file: File): boolean {
    return /^image\//.test(file.type);
  }
  //File Upload ends

  //Find Touch Device - for dispatcher board
  isTouchDevice() {
    return typeof window.ontouchstart !== 'undefined';
  }

  //service - Api calls
  getDefaultRowCount(CompanyId: number, SettingId: number): Observable<SystemSetting[]> {
    return this.http.get(API.SYSTEMSETTING + "/GetSystemSettingByIds/" + CompanyId + '/' + SettingId).pipe(map(res => {
      let resp = res.json()
      return resp;
    }));
  }

  //Added by Anvardeen Batcha - PT-3119
  getSystemSettingByIds(companyId: number, settingId: number): Observable<SystemSetting[]> {
    return this.http.get(API.SYSTEMSETTING + "/GetSystemSettingByIds/" + companyId + "/" + settingId).pipe(map(resp => resp.json()));
  }
  //Added by Anvardeen Batcha - PT-3119

  getConfigSettingByIds(companyId: number, ConfigIds: string[]): Observable<ConfigSettings[]> {
    return this.http.post(API.IMPORTDATA + "/GetConfigSettingByIds/" + companyId, ConfigIds).pipe(map(resp => resp.json()));
  }

  //added for model attachment
  getModelAttachment(CompanyId: number, ModelId: number): Observable<AttachmentsModel[]> {

    return this.http.get(API.MODEL + '/GetAttachment?CompanyId=' + CompanyId + '&ModelId=' + ModelId).pipe(map(this.extractData));
  }

  getJobStatusColorCode(companyId: number): Observable<JobStatusColorCode[]> {
    return this.http.get(API.SYSTEMSETTING + "/GetJobStatusColorCode/" + companyId).pipe(map(res => res.json()));
  }
  getWoStatusColorCode(companyId: number): Observable<WoStatusColorCode[]> {
    return this.http.get(API.SYSTEMSETTING + "/GetWoStatusColorCode/" + companyId).pipe(map(res => res.json()));
  }
  getQOStatusColorCode(companyId: number): Observable<QOStatusColorCode[]> {
    return this.http.get(API.SYSTEMSETTING + "/GetQOStatusColorCode/" + companyId).pipe(map(res => res.json()));
  }
  private extractData(res: Response) {
    let body = res.json();
    return body || {};
  }

  /*** Handle Http operation that failed.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   ****/
  public handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
  private log(message: string) {
    console.error(message);
    //this.messageService.add('HeroService: ' + message);
  }
  /** handle error ends */
  SendGroupMessage(conversationmessage: ConversationMessage): Observable<any> {
    return this.http.post(API.WORKORDER + '/SendGroupMessage', conversationmessage).pipe(map(resp => resp.json()));
  }

  AddNewNumber(newNumber: NewNumber): Observable<any> {
    return this.http.post(API.WORKORDER + '/AddNewNumber', newNumber).pipe(map(resp => resp.json()));
  }
  AddNewGroup(newNumber: NewGroup): Observable<any> {
    return this.http.post(API.WORKORDER + '/AddNewGroup', newNumber).pipe(map(resp => resp.json()));
  }
  downloadFile(filename, blob) {

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      let a: any = document.createElement('a');
      a.style = "display: none";
      var url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      // setTimeout(function () {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      // }, 100);
    }
  }
  loadDynamicScript(): DynamicScriptLoaderService {
    return new DynamicScriptLoaderService();
  }

  getMapKey(Key: string): Observable<FPResponse> {

    return this.http.get(API.COMPANYMASTER + '/GetMapKey' + '?ProdMapKey=' + Key).pipe(
      map(this.extractData));
  }

  GetImageByte(FilePath: string) {
    return this.http.get(API.VENDORATTACH + '/GetImageByte?FilePath=' + FilePath).pipe(map(resp => resp.json()));
  }

  getCompany(companyId: number): Observable<CompanyMaster> {
    return this.http.get(API.COMPANY + '/Get/?CompanyId=' + companyId).pipe(map(res => res.json()));
  }

  getEnableOTP(companyId: number) {
    return this.http.get(API.COMPANY + '/GetOTPEnable/?CompanyId=' + companyId).pipe(map(resp => resp.json()));
  }
  searchCustomerslookup(customerdetail: Customerdetails): Observable<CustomerDetailsListEntity> {
    return this.http.post(API.CUSTOMER + "/GetCustomerListLookup", customerdetail).pipe(map(res => res.json()));
  }
  getCustomerTypes(companyId: number): Observable<CustomerType[]> {
    return this.http.get(API.CUSTOMER + '/GetCustomerTypes/' + companyId).pipe(map(res => res.json()));
  }
  getPaswordComplexity(CompanyId: number, Password: string): Observable<string[]> {
    return this.http.post(API.SYSTEMSETTING + "/GetPaswordComplexity/" + CompanyId, { 'Password': Password }).pipe(map(res => res.json()));
  }

  addCustomerType(customerType: CustomerTypeSaveEntity): Observable<FPResponse> {
    return this.http.post(API.CUSTOMERTYPE, customerType).pipe(
      map(res => res.json()));
  }
  insertContractType(savecontractype: SaveContractType): Observable<FPResponse> {debugger
    return this.http.post(API.BRAND + '/savecontracttype', savecontractype).pipe(map(res => res.json()));
  }
  updateContractType(savecontractype: SaveContractType): Observable<FPResponse> {debugger
    return this.http.put(API.BRAND + '/Updatecontracttype', savecontractype).pipe(map(res => res.json()));
  }
 insert(saveproductcategory: SaveProductCategory): Observable<FPResponse> {
  return this.http.post(API.BRAND + '/saveproductcategory', saveproductcategory).pipe(map(res => res.json()));
 }
update(saveproductcategory: SaveProductCategory): Observable<FPResponse> {
    return this.http.put(API.BRAND + '/Updateproductcategory', saveproductcategory).pipe(map(res => res.json()));
}



// getProduct(CompanyId: number, ProductCategoryId: number): Observable<SaveProductCategory> {
//     return this.http.get(API.BRAND + "/" + CompanyId + "/" + ProductCategoryId).pipe(map(res => res.json()));
// }
getContract(CompanyId: number, ContractTypeId: number): Observable<SaveContractType> {debugger
  return this.http.get(API.BRAND + '/GetContract/' + CompanyId  + "/" + ContractTypeId).pipe(map(res => res.json()));
}
getProduct(CompanyId: number, ProductCategoryId: number): Observable<SaveProductCategory> {
    return this.http.get(API.BRAND + '/GetProduct/' + CompanyId  + "/" + ProductCategoryId).pipe(map(res => res.json()));
}

} // SharedService ends
/***** Shared Service class ends ***************************************************************************************/

export class Status {
  constructor(public id: number,
    public name: string) { }
}

export class IsOptional {
  constructor(public id: number,
    public name: string) { }
}

export class RowsPerOptions {
  constructor(public id: number,
    public name: string) { }
}

//For Resource File
export class Language {
  constructor(public languageid: number,
    public languagename: string) { }
}
// For Live Map View mode
export class ViewMode {
  constructor(public Id: number,
    public Mode: string) { }
}
export class DefaultCountryLatLong {
  constructor(public CountryId: number,
    public CountryName: string,
    public Latitute: number,
    public Longutide: number
  ) { }
}

export class LiveMapType {
  constructor(public Id: number,
    public Type: string) { }
}
export class OptimizationViewMode {
  constructor(public Id: number,
    public Mode: string) { }
}

export class Scope {
  constructor(public ScopeId: number,
    public ScopeName: string) { }
}

//load dynamic script added by senthilg
declare var document: any;
export const ScriptStore: Scripts[] = [
  { name: 'chartjs', src: 'https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.7.2/Chart.bundle.min.js' },
  { name: 'bing-map', src: 'https://www.bing.com/api/maps/mapcontrol?callback=GetMap' },
  { name: 'datamaps-world', src: 'assets/js/datamaps/datamaps.world.hires.min.js' },
  { name: 'datamaps-all', src: 'assets/js/datamaps/datamaps.all.hires.min.js' },
  { name: 'drag-drop-touch', src: 'assets/DragDropTouch.js' },
  { name: 'powerbi', src: 'assets/js/powerbi.js' },
  { name: 'jsts', src: 'assets/js/jsts.min.js' },
  { name: 'jspdf', src: 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/1.0.272/jspdf.min.js' },
  { name: 'jspdf-autotable', src: 'https://cdnjs.cloudflare.com/ajax/libs/jspdf-autotable/2.0.16/jspdf.plugin.autotable.js' },
  { name: 'd3', src: 'https://cdnjs.cloudflare.com/ajax/libs/d3/3.5.3/d3.min.js' },
  { name: 'topojson', src: 'https://cdnjs.cloudflare.com/ajax/libs/topojson/1.6.9/topojson.min.js' },
  { name: 'animatedmaps', src: 'assets/js/bing-refer/AnimatedMaps.js' },
  { name: 'animationmodule', src: 'assets/js/bing-refer/AnimationModule.js' }
];


export class DynamicScriptLoaderService {

  private scripts: any = {};

  constructor() {
    ScriptStore.forEach((script: any) => {
      this.scripts[script.name] = {
        loaded: false,
        src: script.src
      };
    });
  }

  load(...scripts: string[]) {

    const promises: any[] = [];
    scripts.forEach((script) => promises.push(this.loadScript(script)));
    return Promise.all(promises);
  }

  loadScript(name: string) {
    return new Promise((resolve, reject) => {
      if (!this.scripts[name].loaded) {
        //load script
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = this.scripts[name].src;
        if (script.readyState) {  //IE
          script.onreadystatechange = () => {
            if (script.readyState === "loaded" || script.readyState === "complete") {
              script.onreadystatechange = null;
              this.scripts[name].loaded = true;
              resolve({ script: name, loaded: true, status: 'Loaded' });
            }
          };
        } else {  //Others
          script.onload = () => {
            this.scripts[name].loaded = true;
            resolve({ script: name, loaded: true, status: 'Loaded' });
          };
        }
        script.onerror = (error: any) => resolve({ script: name, loaded: false, status: 'Loaded' });
        document.getElementsByTagName('head')[0].appendChild(script);

      } else {
        resolve({ script: name, loaded: true, status: 'Already Loaded' });
      }
    });
  }


}




